import React, { Suspense } from 'react';
import { Switch } from 'react-router';
import { styled } from '@material-ui/core/styles';
import { Route } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import { currentUserVar, errorsVar } from '../../cache';
import ChartDetailsPage from '../pages/ChartDetailsPage';
import DatasourcesEdit from '../pages/DatasourcesEdit';
import DatasourcesNew from '../pages/DatasourcesNew';
import Datasources from '../pages/Datasources';
import DestinationDetailsPage from '../pages/DestinationDetailsPage';
import DestinationsListPage from '../pages/DestinationsListPage';
import ExplorePage from '../pages/ExplorePage';
import AppBar from '../components/AppBar';
var SignedInScreen = function (_a) {
    var className = _a.className;
    var currentUser = useReactiveVar(currentUserVar);
    var errors = useReactiveVar(errorsVar);
    return currentUser && !(errors === null || errors === void 0 ? void 0 : errors.some(function (e) { return e.name === 'Fatal'; })) ? (React.createElement(Root, { className: className },
        React.createElement(Suspense, { fallback: React.createElement("div", null) },
            React.createElement(AppBar, null),
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: "/chart/:chartId", component: ChartDetailsPage }),
                React.createElement(Route, { exact: true, path: "/datasources/:datasourceId/edit", component: DatasourcesEdit }),
                React.createElement(Route, { exact: true, path: "/datasources/new", component: DatasourcesNew }),
                React.createElement(Route, { exact: true, path: "/datasources", component: Datasources }),
                React.createElement(Route, { exact: true, path: "/destinations/:destinationId", component: DestinationDetailsPage }),
                React.createElement(Route, { exact: true, path: "/destinations", component: DestinationsListPage }),
                React.createElement(Route, { exact: true, path: "/", component: ExplorePage }))))) : null;
};
var Root = styled('div')({});
export default SignedInScreen;
